module.exports = __webpack_public_path__ + "static/img/ikonaIrfanDisabled-ON.70b2b7d4.png";